import React from "react";

type HeadingProps = {
  children: React.ReactNode;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  className?: string;
}

export function Heading({ children, as: Tag = "h1", className }: HeadingProps) {
  return (
    <Tag
      className={[
        "font-bold ",
        Tag === "h1" && "text-[34px] lg:text-[40px] font-bold text-primaryGreen leading-[1.2] lg:leading-[1.4] mb-3 font-playfair",
        Tag === "h2" && "text-3xl md:text-4xl font-bold leading-[45px] mb-4 font-playfair",
        Tag === "h3" && "text-2xl md:text-3xl",
        Tag === "h4" && "text-xl md:text-2xl",
        Tag === "h5" && "text-lg md:text-xl",
        Tag === "h6" && "text-base md:text-lg",
        className ?? "",
      ].join(" ")}
    >
      {children}
    </Tag>
  );
}
